(function () {
    'use strict';

    angular
        .module('jotApp')
        .directive('objectTypeFilter', objectTypeFilter);

    function objectTypeFilter() {
        var directive = {
            restrict: 'E',
            scope: {
                filter: '&',
                device: '&',
                deviceVal: '&'
            },
            template:   '<div class="row">\n' +
            '    <div class="col-xs-12">\n' +
            '        <div class="portlet light filter-portlet bordered">\n' +
            '            <div class="portlet-body form">\n' +
            '                <form ng-submit="vm.submit()" class="horizontal-form">\n' +
            '                    <div class="form-body">\n' +
            '                       <div class="row">\n' +
            '                            <div class="col-xs-5">\n' +
            '                                <div class="form-group">\n' +
            '                                    <label for="field_device">Device</label>\n' +
            '                                       <ui-select ng-model="vm.device" id="device_field" theme="bootstrap">\n' +
            '                                       <ui-select-match\n' +
            '                                           placeholder="Select or search a device...">\n' +
            '                                           {{$select.selected.deviceName}}\n' +
            '                                       </ui-select-match>\n' +
            '                                       <ui-select-choices repeat="item in vm.tabDevices | filter: {deviceName: $select.search}">\n' +
            '                                           <div ng-bind-html="item.deviceName | highlight: $select.search"></div>\n' +
            '                                       </ui-select-choices>\n' +
            '                                       </ui-select>\n' +
            '                                </div>\n' +
            '                            </div>\n' +
            '                            <div class="col-xs-2 inline-filter-button">\n' +
            '                                <div class="form-group">\n' +
            '                                    <label class="control-label ng-scope" for="submit_field"></label>\n' +
            '                                    <button type="submit" id="submit_field" class="btn btn-primary">\n' +
            '                                        <span class="fa fa-filter"></span>&nbsp;<span translate="entity.action.filter">Filter</span>\n' +
            '                                    </button>\n' +
            '                                </div>\n' +
            '                            </div>\n' +
            '                       </div>\n' +
            '                    </div>\n' +
            '                </form>\n' +
            '            </div>\n' +
            '        </div>\n' +
            '    </div>\n' +
            '</div>\n',
            controller: ObjectTypeFilterController,
            controllerAs: 'vm',
            bindToController: true
        };
        return directive;
    }

    ObjectTypeFilterController.$inject = ['TabDevices'];

    function ObjectTypeFilterController(TabDevices) {
        var vm=this;
        TabDevices.query({size: 1000}, onSuccessDevice, onError);


        function onSuccessDevice(data) {
            vm.tabDevices = data;
            vm.tabDevices.unshift(allTabDevices);
        }

        function onError() {}

        var allTabDevices = {
            id: -1,
            deviceName: "All"
        };

        vm.device = +vm.deviceVal() === -1 || +vm.deviceVal().id === -1 ? allTabDevices : vm.deviceVal();

        vm.submit = function () {
            vm.filter({device: vm.device});
        };

    }
})();
